module.exports = __webpack_public_path__ + "static/media/handla-ikon.5486c058.png";